"use strict";

import menu from './modules/menu.mjs';
import magnificPopup from './modules/magnific-popup.mjs';
import loading from './modules/loading.mjs';
import animations from './modules/animations.mjs';
import backgroundImageCarousel from './modules/background-image-carousel.mjs';
import tcNeosElementsBootstrap from 'tc-neos-elements-bootstrap';
import tcNeosElements from 'tc-neos-elements'; // do not remove this line, even if it is not used (Google Maps call initMap() from this file)

// Expose tcNeosElementsBootstrap globally for use in other modules
window.tcNeosElementsBootstrap = tcNeosElementsBootstrap;

document.addEventListener('DOMContentLoaded', () => {
  loading.init();
  menu.buildDesktopMenu();
  tcNeosElementsBootstrap.anchor();
  window.addEventListener('hashchange', () => {
    tcNeosElementsBootstrap.anchor()
  });

  if (!document.body.classList.contains('neos-backend')) {
    menu.buildMobileMenu();
    magnificPopup.init();
    animations.init();
    backgroundImageCarousel.init();
  }
});
